import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  const [isUrgent, setIsUrgent] = useState(false);
  useEffect(() => {
    // Check if we have a saved end time in sessionStorage
    const savedEndTime = sessionStorage.getItem('offerEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
    } else {
      // Set new end time 15 mins from now
      endTime = Date.now() + 15 * 60 * 1000;
      sessionStorage.setItem('offerEndTime', endTime.toString());
    }
    const updateTimer = () => {
      const now = Date.now();
      const difference = Math.max(0, Math.floor((endTime - now) / 1000));
      setTimeLeft(difference);
      setIsUrgent(difference < 5 * 60); // Under 5 minutes
      if (difference <= 0) {
        clearInterval(intervalId);
      }
    };
    updateTimer(); // Initial call
    const intervalId = setInterval(updateTimer, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className={`flex items-center justify-center space-x-2 font-bold text-xl ${isUrgent ? 'text-urgency-600 animate-pulse' : 'text-gray-800'} ${className}`} data-id="element-78">
      <Clock className="w-6 h-6" data-id="element-79" />
      <span className="text-[20px]" data-id="element-80">
        {minutes.toString().padStart(2, '0')} Minutos :{' '}
        {seconds.toString().padStart(2, '0')} Segundos
      </span>
    </div>;
}